import script from "./Page1.vue?vue&type=script&setup=true&lang=js"
export * from "./Page1.vue?vue&type=script&setup=true&lang=js"

import "./Page1.vue?vue&type=style&index=0&id=2add8dd0&lang=less"

const __exports__ = script;

export default __exports__